import { actions } from '../actions';
import { reduxSwitch } from '../../../tools';

const defaultState = {
	preview: null,
	list: null,
	uri: null,
	parameters: null,
	hasMore: null,
	pending: false,
	error: null,
	at: null,
	// export
	exporting: false,
	progress: null, // { percent, done, total }
	csv: null,
};

const updateAnchor = (parameters, locations) => {
	if (locations && locations.length > 0) {
		let location = locations[locations.length-1];
		let anchorAt = parameters.timeRange.retrospective
			? location.since
			: location.upTo
		;
		parameters.timeRange.window.anchorAt = anchorAt;
	}
	return parameters;
}

function apiReducer(state, action) {
	let _state;
	switch (action.type) {
		case actions.locationHistory.request.type:
			if (action.clear) {
				_state = { ...defaultState };
			} else {
				_state = {...state};
			}
			return {
				..._state,
				uri: action.uri,
				parameters: action.parameters,
				pending: true,
				error: null,
				at: action.clear ? new Date() : _state.at
			};
		case actions.locationHistory.success.type:
			const locations = action.report && action.report.locations;
			const batchSize = state.parameters.timeRange.window.size;
			const hasMore = locations ? locations.length == batchSize : false;
			const list = state.list ? (locations ? state.list.concat(locations) : state.list) : (locations ? [...locations] : []);
			_state = {...state};
			return {
				..._state,
				list,
				parameters: updateAnchor(state.parameters, locations),
				hasMore,
				pending: false
			};
		case actions.locationHistory.fail.type:
			return {
				...state,
				pending: false,
				error: action.errorMessage
			};
		case actions.locationHistory.cancel.type:
			return {
				...state,
				pending: false
			};
		default:
			return state;
	}
}

function exportReducer(state, action) {
	switch (action.type) {
		case actions.locationHistory.export.type:
			return {
				...state,
				exporting: true,
				progress: null,
				csv: null
			}
		case actions.locationHistory.exportProgress.type:
			return {
				...state,
				progress: {
					percent: action.progress,
					done: action.count,
					total: action.total
				}
			}
		case actions.locationHistory.exportDone.type:
			return {
				...state,
				parameters: state.parameters,
				exporting: false,
				csv: action.csv
			}
		case actions.locationHistory.exportClear.type:
			return {
				...state,
				csv: null
			}
		default:
			return state;
	}
}

const reducer = reduxSwitch([apiReducer, exportReducer], defaultState);

export { reducer };
